export const errorCategoryMap = {
    validation: "validation",
    invariant: "invariant",
    service: "service",
    api: "api",
} as const;
export type ErrorCategory = (typeof errorCategoryMap)[keyof typeof errorCategoryMap];

export type ErrorContext = {
    readonly category: ErrorCategory;
    readonly component?: string;
    readonly operation?: string;
};

export class SiError extends Error {
    readonly context: ErrorContext;

    constructor(message: string, context: ErrorContext, options?: ErrorOptions) {
        super(`[SI:${context.category}] ${message}`, options);

        this.name = "SiError";
        this.context = context;
    }
}
export const isSiError = (error: unknown): error is SiError => error instanceof SiError;
